import { ActionType } from '../models/batch';
import { BatchData } from './batch.service';

export enum ToastMessageType {
  Pending = 'pending',
  Success = 'success',
}

const messageMap = {
  [ToastMessageType.Pending]: {
    update: {
      status: 'Preparing to change status...',
      project_id: 'Preparing to change project...',
      assigned_to_id: 'Preparing to change assignment...',
      default: 'Preparing to update records...',
    },
    delete: {
      default: 'Preparing to delete records...',
    },
    default: 'Preparing to process records...',
  },
  [ToastMessageType.Success]: {
    update: {
      status: 'Changing status...',
      project_id: 'Changing project...',
      assigned_to_id: 'Changing assignment...',
      default: 'Updating records...',
    },
    delete: {
      default: 'Deleting records...',
    },
    default: 'Processing records...',
  },
};

const batchToastMessages = (type: ToastMessageType, action: ActionType, data: BatchData): string => {
  const actionMessages = messageMap[type][action] || messageMap[type].default;
  const keys = Object.keys(data);
  for (const key of keys) {
    if (actionMessages[key]) {
      return actionMessages[key];
    }
  }
  return actionMessages.default || messageMap[type].default;
};

export default batchToastMessages;
